import React, { Fragment } from "react";

import { Col, Collapse, Row } from "antd";

import Container from "@/components/container/Container";
import ButtonComponent from "@/components/button/Button";
import IconMinus from "@/components/icons/IconMinus";
import IconAdd from "@/components/icons/IconAdd";

import "@/styles/components/faq.scss";
import { useNavigate } from "react-router-dom";

const { Panel } = Collapse;

const FaQ = () => {
  const navigate = useNavigate();
  const data = {
    heading: "Get Answers to Your Questions",
    accordion: [
      {
        q: "What can Inforens do for me?",
        a: "<span>We're your sidekick throughout your study abroad adventure! From application support to post-study guidance, we've got your back. Check out our Champions Bundle for the full Inforens experience!</span>",
      },
      {
        q: "Is Inforens free?",
        a: "<span>While we invest in finding top-notch student mentors, our mission is about supporting your growth, not maximizing profits. Costs vary depending on the services you choose. Visit our Offerings page for details!</span>",
      },
      {
        q: "What's included in the Champions Bundle?",
        a: "<div><div>Our most popular package offers:</div><ul style=padding-left:10%><li>2 years of access to our services</li><li>Quick-call support for any queries</li><li>Comprehensive application assistance</li></ul><div><b>99% of our students choose this option - join the champions!</b></div></div>",
      },
    ],
  };

  const customExpandIcon = ({ isActive }) => (isActive ? <IconMinus /> : <IconAdd />);

  return (
    <Fragment>
      <div className="faq">
        <Container>
          <Row gutter={[0, 0]}>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <div className="heading title-h5-1">{data.heading}</div>
              <Collapse
                accordion
                expandIcon={customExpandIcon}
                expandIconPosition="right"
                className="accordion"
              >
                {data.accordion.map((item, index) => {
                  return (
                    <Fragment key={index + 1}>
                      <Panel header={`${index + 1 + ". "}${item.q}`} key={index + 1}>
                        <div className="content">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: item.a,
                            }}
                          />
                        </div>
                      </Panel>
                    </Fragment>
                  );
                })}
              </Collapse>
              <div className="view-questions">
                <ButtonComponent
                  label="View More Questions"
                  varient="dark"
                  onClick={() => navigate("/faq")}
                >
                  <img src="/assets/images/arrow-tr.svg" alt="" width="24" height="24" />
                </ButtonComponent>
              </div>
            </Col>
            {/* <Col xs={24} sm={24} md={24} lg={8} xl={8} className="image">
              <img
                src="/assets/images/faq.png"
                alt="Graduate"
                className="image"
              />
            </Col> */}
          </Row>
        </Container>
      </div>
    </Fragment>
  );
};

export default FaQ;
